import React from 'react';
import colors from '../../util/colors';
import './styles.scss';

interface AppDownloadButtonProps {
  color?: string;
}

function AppDownloadButton({color = colors.black}: AppDownloadButtonProps) {
  return (
    <svg
      width="24px"
      height="23px"
      viewBox="0 0 24 23"
      version="1.1"
      className="download-icon">
      <title>FBFFE45F-F079-4C70-9485-644280CF94C9</title>
      <g
        id="04--Pedidos"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="MY-D-04-01-19-pedido-reembolso"
          transform="translate(-665.000000, -1332.000000)">
          <g id="Group" transform="translate(209.000000, 1290.000000)">
            <g
              id="buttons/menu_internal"
              transform="translate(0.000000, 26.000000)">
              <g id="Group"></g>
              <g
                id="cards/close_icon"
                transform="translate(456.695266, 16.000000)"
                fill={color}>
                <path
                  d="M7.29147816,3.68965937 L12.3593971,8.2609385 L7.2398755,12.8787634 C7.11143164,12.9945621 7.03014055,13.1536048 7.01147482,13.3255314 C6.95658838,13.8310801 7.09860187,14.2966606 7.43751527,14.7222727 C7.76495287,15.1334734 8.19469434,15.4050336 8.72673968,15.5369532 C8.9504654,15.5923803 9.18716479,15.5348186 9.36042451,15.3828107 L16.0151228,9.54436687 C16.7987281,8.92038488 16.8379084,7.75816336 16.1326636,7.08035742 L9.40117977,1.17482262 C9.21227519,1.00907501 8.94933978,0.956604625 8.71128258,1.03714023 C8.09602067,1.24528556 7.67143157,1.4962359 7.43751527,1.78999124 C7.19812471,2.09062125 7.07199701,2.54463439 7.0591322,3.15203065 C7.05485171,3.35647424 7.13963448,3.55269588 7.29147816,3.68965937 Z"
                  id="Path"
                  transform="translate(11.816879, 8.278814) rotate(-270.000000) translate(-11.816879, -8.278814) "></path>
                <rect
                  id="Rectangle"
                  x="3"
                  y="17"
                  width="17"
                  height="3"
                  rx="1"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AppDownloadButton;
